module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page37",
      "title": "37"
    }
  }, [_c('h1', {
    staticClass: "sb-title"
  }, [_c('span', {
    staticClass: "greenh"
  }, [_vm._v("PANCAKES")])]), _vm._v(" "), _c('h1', {
    staticClass: "sb-title"
  }, [_c('span', {
    staticClass: "color30"
  }, [_vm._v("BASIC PANCAKE DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap color30"
  }, [_vm._v("1")]), _vm._v(" Slowly warm a nonstick skillet over low heat. Pancakes cook best on a skillet that is evenly and fully warmed up to prevent burning or uneven cooking (gooey insides). Raise the heat to medium when ready to cook. Slow cooking on a properly warmed skillet will yield golden and fluffy pancakes. A good 3 to 5 minutes is needed to warm the skillet.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap color30"
  }, [_vm._v("2")]), _vm._v(" While the skillet is warming up, place the dry ingredients in a bowl. Blend them together, using a sifter to remove any clumps in the flour. Stir in the wet ingredients until the batter is smooth and silky. Fold in any accent ingredients like fruit, nuts, or seeds. You could also add these directly to the pancakes while they are cooking on the first side. For example, you can press fresh blueberries into the just-poured pancakes.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap color30"
  }, [_vm._v("3")]), _vm._v(" Once the skillet is warmed evenly, coat the pan with a drizzle of oil so the pancakes do not stick. I like to use safflower or virgin coconut oil for my pancakes. The oil also adds toasty, buttery edges to the pancakes. Wait another minute and then start adding the batter about 2 tablespoons per pancake for small pancakes or 3 to 4 tablespoons for large pancakes. Allow the pancake to slowly cook, as tiny bubbles form through the surface of the batter, until the edges are firmed, cooked, fluffy, and not wet, 2 to 3 minutes. Lift the bottom edges of the pancake with a spatula and flip the pancake. Cook for 2 to 3 minutes on the second side.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap color30"
  }, [_vm._v("4")]), _vm._v(" Transfer the cooked pancakes to a paper towel–lined plate and repeat until all the batter has been used. Add oil to the pan before each new batch of pancakes.")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_c('span', {
    staticClass: "dropcap color30"
  }, [_vm._v("5")]), _vm._v(" Serve warm with vegan buttery spread, jam, fruit toppings, and/or maple syrup, if desired.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-tip"
  }, [_c('strong', {
    staticClass: "tip-leadin"
  }, [_vm._v("Note:")]), _vm._v(" Most of the cooking should be done before that first flip, so just another minute or two on the other side should do it.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-tip"
  }, [_c('strong', {
    staticClass: "tip-leadin"
  }, [_vm._v("Tip:")]), _vm._v(" If you are worried about the pancakes sticking when flipped, add a spray of oil to the top side of the uncooked pancake just before flipping.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-tip"
  }, [_c('strong', {
    staticClass: "tip-leadin"
  }, [_vm._v("Tip:")]), _vm._v(" To speed up the cooking process, cover the skillet with a lid for the first minute of cooking to trap in the heat and cook the top side of the pancake a bit faster, still using low heat.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7ff4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/page037.vue
// module id = 108
// module chunks = 0